import { DATA_SOURCES } from "../../lib/pipeline";
import { Card } from "../ui/card";
import { Textarea } from "../ui/textarea";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "../ui/select";
import { Checkbox } from "../ui/checkbox";
import { Badge } from "../ui/badge";
import { CheckCircle2, Circle } from "lucide-react";
import { MIGRATION_STATUS_LABEL, migrationSteps } from "../../lib/prospectDetail";

// Fiche prospect › Migration: method, owner and the four data milestones.
export default function MigrationTab({ migration, canManage, userName, onUpdate }) {
  return (
    <Card className="p-5 space-y-4">
      <div className="flex items-center justify-between">
        <h4 className="font-display font-semibold text-slate-900">Mise en place des données</h4>
        <Badge variant="outline">{MIGRATION_STATUS_LABEL[migration?.status || "not_started"]}</Badge>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div>
          <Label className="text-xs">Méthode</Label>
          {canManage ? (
            <Select value={migration?.method || undefined} onValueChange={(v) => onUpdate({ method: v })}>
              <SelectTrigger data-testid="select-migration-method" className="mt-1.5">
                <SelectValue placeholder="Choisir une méthode" />
              </SelectTrigger>
              <SelectContent>
                {DATA_SOURCES.map((s) => (
                  <SelectItem key={s.id} value={s.id}>{s.label}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          ) : (
            <div className="text-sm text-slate-900 mt-1.5">
              {DATA_SOURCES.find((s) => s.id === migration?.method)?.label || "Non choisie"}
            </div>
          )}
        </div>
        <div>
          <Label className="text-xs">Responsable</Label>
          <div className="text-sm text-slate-900 mt-1.5">{userName(migration?.responsible_user_id) || "Aucun responsable"}</div>
        </div>
        <div>
          <Label className="text-xs">Démarrée le</Label>
          <div className="text-sm text-slate-900 mt-1.5">
            {migration?.started_at ? new Date(migration.started_at).toLocaleDateString("fr-FR") : "Pas commencée"}
          </div>
        </div>
      </div>
      {migration?.method === "other_software" && (
        <div>
          <Label className="text-xs">Logiciel source</Label>
          {canManage ? (
            <Input
              data-testid="input-source-software"
              defaultValue={migration?.source_software || ""}
              onBlur={(e) => onUpdate({ source_software: e.target.value })}
              placeholder="Nom du logiciel"
              className="mt-1.5"
            />
          ) : (
            <div className="text-sm text-slate-900 mt-1.5">{migration?.source_software || "Non renseigné"}</div>
          )}
        </div>
      )}
      <div className="border-t border-slate-100 pt-4">
        <h5 className="text-xs font-semibold text-slate-500 uppercase tracking-wider mb-2">Suivi</h5>
        <ul className="space-y-2">
          {migrationSteps(migration?.method).map(([key, label]) => (
            <li key={key} className="flex items-center gap-3">
              {canManage ? (
                <Checkbox
                  checked={!!migration?.[key]}
                  onCheckedChange={(v) => onUpdate({ [key]: !!v })}
                  data-testid={`checkbox-${key}`}
                />
              ) : migration?.[key] ? (
                <CheckCircle2 className="text-jamora-light" size={16} />
              ) : (
                <Circle className="text-slate-300" size={16} />
              )}
              <span className="text-sm">{label}</span>
            </li>
          ))}
        </ul>
      </div>
      <div className="border-t border-slate-100 pt-4">
        <Label className="text-xs">Notes</Label>
        {canManage ? (
          <Textarea
            data-testid="textarea-migration-notes"
            defaultValue={migration?.notes || ""}
            onBlur={(e) => onUpdate({ notes: e.target.value })}
            placeholder="Ce qui bloque, prochaine action..."
            className="mt-1.5"
            rows={3}
          />
        ) : (
          <p className="text-sm text-slate-900 mt-1.5 whitespace-pre-wrap">{migration?.notes || "Aucune note"}</p>
        )}
        <div className="text-xs text-slate-400 mt-2">
          Dernière mise à jour : {migration?.updated_at ? new Date(migration.updated_at).toLocaleString("fr-FR") : "jamais"}
        </div>
      </div>
    </Card>
  );
}
